import authSliderSaga from './authSliderSaga'
import authDynamicSaga from './authDynamicEventSaga'

const uiSaga = [authSliderSaga(), authDynamicSaga()]

export default uiSaga
